import type { EntryPoint } from '#packages/apilib';
import { EditorAPIKey } from '#packages/apis';
import { createAdvancedMenu } from './createAdvancedMenu';
import { AdvancedMenuApiKey } from '../publicApiKey';

export const AdvancedMenuEntryPoint: EntryPoint = {
  name: 'AdvancedMenuApi',
  declareAPIs: () => [AdvancedMenuApiKey],
  getDependencyAPIs: () => [EditorAPIKey],
  attach(shell) {
    shell.contributeAPI(AdvancedMenuApiKey, () => createAdvancedMenu(shell));
  },
};
